import React, { useEffect, useState } from 'react';

export default function ScoreCircle({ score = 0, size = 120, showLabel = true }) {
	const radius = (size - 10) / 2;
	const circumference = 2 * Math.PI * radius;
	const [display, setDisplay] = useState(0);

	useEffect(() => {
		let frame;
		const start = performance.now();
		const duration = 800;
		function tick(now) {
			const p = Math.min(1, (now - start) / duration);
			setDisplay(Math.round(score * p));
			if (p < 1) frame = requestAnimationFrame(tick);
		}
		frame = requestAnimationFrame(tick);
		return () => cancelAnimationFrame(frame);
	}, [score]);

	const percent = Math.max(0, Math.min(100, score));
	const offset = circumference - (percent / 100) * circumference;

	const color =
		percent <= 40 ? '#ef4444' : percent <= 60 ? '#f59e0b' : percent <= 80 ? '#eab308' : '#22c55e';

	return (
		<div className="relative inline-block" style={{ width: size, height: size }}>
			<svg width={size} height={size}>
				<circle
					stroke="#e5e7eb"
					fill="transparent"
					strokeWidth="10"
					r={radius}
					cx={size / 2}
					cy={size / 2}
				/>
				<circle
					stroke={color}
					fill="transparent"
					strokeWidth="10"
					strokeLinecap="round"
					style={{
						strokeDasharray: `${circumference} ${circumference}`,
						strokeDashoffset: offset,
						transition: 'stroke-dashoffset 0.6s ease'
					}}
					r={radius}
					cx={size / 2}
					cy={size / 2}
				/>
			</svg>
			{showLabel && (
				<div className="absolute inset-0 flex items-center justify-center">
					<div className="text-center">
						<div className="text-xl font-bold">{display}</div>
						<div className="text-xs text-gray-500">ATS</div>
					</div>
				</div>
			)}
		</div>
	);
}


